module.exports = __webpack_public_path__ + "static/swni-40b9d5866835a2bf058bcf2f87ff4604.png";